import React, {useState, useEffect} from 'react'
import {Table, Button, Input, Spin, Row, Col} from 'antd'
import {SearchOutlined} from '@ant-design/icons'
import apiRequest from '../hooks/ApiRequest'
import Layouts from '../components/Layouts'
import useDownloadPdf from '../hooks/DownloadPdf'

const PaymentHistory = () => {
  const [nationalID, setNationalID] = useState('')
  const [baseData, setBaseData] = useState([])
  const [loading, setLoading] = useState(false)
  const {generatePdf} = useDownloadPdf()
  const UserDetail = JSON.parse(localStorage.getItem('user'))
  useEffect(() => {
    fetchRoles()
  }, [])

  const fetchRoles = async () => {
    setLoading(true)
    try {
      const response = await apiRequest(
        process.env.REACT_APP_BASE_URL + `/api/PaypalWebhook/getPaymenthistoryby-email?email=${UserDetail?.email}`,
      )
    //   setBaseData(response?.data)
    const filteredData = response?.data?.filter(
        item => item.payment_type?.toLowerCase() !== "Debit" && item.payment_type?.toLowerCase() !== "Credit"
      );
      setBaseData(filteredData);
    } catch (error) {
      console.error('Error fetching insurers', error)
    } finally {
      setLoading(false)
    }
  }

  const handleSearch = () => {
    fetchRoles()
  }

  const columns = [
    {
      title: 'Policy Number',
      dataIndex: 'policy_number',
      key: 'policy_number',
    },
    {
      title: 'Payment Status',
      dataIndex: 'payment_status',
      key: 'payment_status',
      render: text => (
        <span style={{color: text === 'Paid' ? 'green' : 'red'}}>{text}</span>
      ),
    },
    {
      title: 'Transaction Reference',
      dataIndex: 'transaction_ref',
      key: 'transaction_ref',
      render: text => text || '—',
    },
    {
      title: 'Payment Type',
      dataIndex: 'payment_type',
      key: 'payment_type',
    },
    {
      title: 'Payment Amount',
      dataIndex: 'payment_amount',
      key: 'payment_amount',
      render: amount => `$${amount.toFixed(2)}`,
    },
    {
      title: 'Premium',
      dataIndex: 'premium',
      key: 'premium',
      render: amount => `$${amount.toFixed(2)}`,
    },
    {
      title: 'Transaction Date',
      dataIndex: 'transaction_date',
      key: 'transaction_date',
      render: date =>
        date && date !== '0001-01-01T00:00:00'
          ? new Date(date).toLocaleString()
          : 'Not Available',
    },
  ]

  return (
    <Layouts title="Insurers" classname="dashboard">
      <div className="dash-bg-white">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={24} lg={12}>
            <div className="section-top-heading">
              <h3
                style={{color: '#0C1362', fontWeight: '600', fontSize: '20px'}}>
                Payment History
              </h3>
            </div>
          </Col>
          <Col xs={24} sm={24} md={24} lg={6}>
            <div className="item-search">
              <Input.Search
                placeholder="Search ..."
                prefix={<SearchOutlined />}
                value={nationalID}
                onChange={e => setNationalID(e.target.value)}
              />
            </div>
          </Col>
          <Col xs={24} sm={24} md={3} lg={2}>
            <div className="create-quotation">
              <Button
                type="primary"
                onClick={handleSearch}
                style={{marginLeft: 10}}>
                Search
              </Button>
            </div>
          </Col>
          <Col xs={24} sm={24} md={3} lg={3}>
            <div className="create-quotation">
              <Button
                type="primary"
                onClick={() => generatePdf('divToPrint', 'payment-history.pdf')}
                style={{marginLeft: 10}}>
                Download
              </Button>
            </div>
          </Col>
        </Row>
      </div>

      {loading ? (
        <Spin
          className="loader-icon-fixed"
          size="large"
          style={{display: 'block', marginTop: 20}}
        />
      ) : (
        <div id="divToPrint">
          <Table columns={columns} dataSource={baseData} rowKey="id" />
        </div>
      )}
    </Layouts>
  )
}

export default PaymentHistory
